var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnlineClass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38292",
    "data-name": "Group 38292",
    transform: "translate(-311 -385)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7661",
    "data-name": "Rectangle 7661",
    width: 31,
    height: 31,
    rx: 5,
    transform: "translate(311 385)",
    fill: "#c7b9eb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "online-course-icon_1_",
    "data-name": "online-course-icon (1)",
    transform: "translate(315.956 394.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65501",
    "data-name": "Path 65501",
    d: "M.468,10.437h1.8a.4.4,0,0,1-.3-.388V.4a.4.4,0,0,1,.4-.4H18.613a.4.4,0,0,1,.4.4v9.648a.4.4,0,0,1-.3.388h1.908a.469.469,0,0,1,.468.468h0a.469.469,0,0,1-.468.468H.468A.469.469,0,0,1,0,10.9H0a.468.468,0,0,1,.468-.467ZM5.133,1.883H9.317V6.9c-.009.141-.189.144-.384.136H5.066a.493.493,0,0,0,0,.985H9.111V7.5H9.5v.666a.22.22,0,0,1-.22.22H5.085A.672.672,0,0,1,4.2,7.678V2.816a.938.938,0,0,1,.934-.934Zm6.319,6.233a.272.272,0,0,1,0-.542h5.026a.272.272,0,0,1,0,.542Zm-.036-5.922h5.538a.218.218,0,0,1,.216.216v.772a.219.219,0,0,1-.216.216H11.415a.218.218,0,0,1-.216-.216V2.409a.216.216,0,0,1,.216-.216Zm.036,2.892a.272.272,0,0,1,0-.542h4.682a.272.272,0,0,1,0,.542Zm0,1.515a.272.272,0,0,1,0-.542H15.4a.272.272,0,0,1,0,.542ZM5.306,2.612h.156a.134.134,0,0,1,.144.117V6.4a.134.134,0,0,1-.144.117H5.306A.134.134,0,0,1,5.162,6.4V2.729a.133.133,0,0,1,.144-.117ZM2.655.626H18.383V9.934H2.655V.626Zm7.5,9.986h1.316a.226.226,0,0,1,.225.225h0a.226.226,0,0,1-.225.225H10.151a.226.226,0,0,1-.225-.225h0a.224.224,0,0,1,.225-.225Z",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineClass);
export default __webpack_public_path__ + "static/media/OnlineClass.f2e4201af8a53c85c29a338697d90009.svg";
export { ForwardRef as ReactComponent };